import React from "react";
import { GolfHeaderContainer } from "../organisms/golfHeaderContainer";
import GolfCompleteContainer from "../organisms/golfCompleteContainer";
import { SubHeader } from '../molecules/subHeader';
import SubHeader4 from '../../resources/image/subHeader4.png';
import GolfReservationPopupContainer from "../organisms/golfReservationPopupContainer";
import { connect } from "react-redux";

class GolfCompleteTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      reserveChangeFlg : false
    };
  };
  componentDidMount() {
    if(this.props.changeReserveNo !== '' && this.props.changeReserveNo !== undefined && this.props.changeReserveNo !== null){
      this.setState({reserveChangeFlg:true});
    }
  }
  render() {
    return (
      <div>
        <GolfHeaderContainer 
          Label categoryLabel1={this.state.reserveChangeFlg ? "予約変更完了" : "予約完了"} 
          categoryLabel2={"COMPLETE"} 
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
        />
        {!this.state.reserveChangeFlg ? 
          <SubHeader SubImage={SubHeader4} />
          :
          null
        }
        <GolfReservationPopupContainer
            state={this.props.state}
            onClickClosePopupWindow={this.props.onClickClosePopupWindow}
        />
        <GolfCompleteContainer 
          completeTitle={this.state.reserveChangeFlg ? "ご予約の変更を承りました" : "ご予約を承りました"} 
          completeBody={"お申込内容をメールでお送りいたしましたので、"}
          completeBody2={"内容をご確認ください。"}
          dispName={"complete"}/>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
      changeReserveNo:state.changeReserveNo,
  };
};
const mapToDispatchToProps = (dispatch) => {
  return {
  };
}
export default connect(mapStateToProps, mapToDispatchToProps)(GolfCompleteTemplate);